import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Button, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Select, TextField, FormControl, InputLabel, MenuItem, Grid } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import { DEPARTMENT_MAP } from "src/config/constants";
import { asyncRequest } from "src/services/network";
import UserInfo from "src/components/common/UserInfo";

const deps = Object.values(DEPARTMENT_MAP);

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false }, 
  { id: "user", label: "用户", alignRight: false }, 
  { id: "district", label: "地区", alignRight: false }, 
  { id: "amount", label: "数额", alignRight: false }, 
  { id: "current", label: "当前剩余", alignRight: false }, 
  // { id: "dep", label: "部门", alignRight: false }, 
  { id: "detail", label: "详情", alignRight: false }, 
  { id: "relation", label: "关联订单", alignRight: false }, 
  { id: "remark", label: "备注", alignRight: false }, 
  { id: "createdAt", label: "创建时间", alignRight: false }, 
  { id: "操作" }
];

const moreMenus = [
  // { title: "编辑", icon: iconEdit2 }
];

export default function AgentBalanceRecord() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/agent/balance/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/user/detail/${row.uid}`);
    }
  };

  const emptyRows = filter.size - items.length;
  const isUserNotFound = items.length === 0;

  return (
    <Page title="代理绩效明细">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            代理绩效明细
          </Typography>
        </Stack>

        <Card>
          <ListToolbar showSearch={false} filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}>
            <Grid container>
              {/* <Grid item md={3}>
                <TextField
                  style={{ width: 200 }}
                  size="small"
                  label="用户ID"
                  placeholder="用户ID"
                  autoComplete="off"
                  id="uid"
                  value={filter.uid}
                  onChange={(e) => {
                    handleFilterChange("uid", e.target.value);
                  }}
                />
              </Grid> */}

              {/* <Grid item md={3}>
                <FormControl size="small">
                  <InputLabel>部门</InputLabel>
                  <Select
                    label="部门"
                    value={filter.type}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        type: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    {[-1, ...deps].map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {idx == 0 ? "全部" : DEPARTMENT_MAP[type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, agent, amount, current, createdAt, remark, dep, relation, detail } = row;
                    const isItemSelected = selected.indexOf(id) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        <TableCell align="left">{id}</TableCell>
                        <TableCell component="th" scope="row">
                          <UserInfo {...agent} />
                        </TableCell>
                        <TableCell align="left">{agent.district}</TableCell>
                        <TableCell align="left">{StringUtil.trimZero(amount)}</TableCell>
                        <TableCell align="left">{StringUtil.trimZero(current)}</TableCell>
                        {/* <TableCell align="left"> {DEPARTMENT_MAP[dep]}</TableCell> */}
                        <TableCell align="left">{detail}</TableCell>
                        <TableCell align="left">{relation}</TableCell>
                        <TableCell align="left">{remark}</TableCell>
                        {/* <TableCell>
                          <Label variant="ghost" color={["warning", "error", "success", "warning"][status]}>
                            {SALARY_RECORD_MAP[type]}
                          </Label>
                        </TableCell> */}
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
